import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import '../../styles/globals.css';

const RatingStars = ({ rating, size = 'md' }) => {
    const starSizes = {
        sm: 'w-3 h-3',
        md: 'w-4 h-4',
        lg: 'w-5 h-5'
    };

    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 1; i <= 5; i++) {
        if (i <= fullStars) {
            stars.push(<FaStar key={i} className={`${starSizes[size]} text-champagne fill-champagne`} />);
        } else if (i === fullStars + 1 && hasHalfStar) {
            stars.push(<FaStarHalfAlt key={i} className={`${starSizes[size]} text-champagne`} />);
        } else {
            stars.push(<FaRegStar key={i} className={`${starSizes[size]} text-nude`} />);
        }
    }

    return <div className="flex items-center gap-1">{stars}</div>;
};

export default RatingStars;